var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import { EdALinkButton, } from "@frameworks/web/components/generic/edbutton/edButton";
import { GenericDropdown } from "../../../../../shared-library/components/GenericDropdown";
import MFSIPRegistrationBook from "./MFSIPRegistrationBook";
import MfSipOrderBook from "./MfSipOrderBook";
import di from "../di/serviceLocator";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../../shared-library/components/Loader";
import { accountDetails } from "@salesdi";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import { getDateInFormat } from "@domains/utils/reportDates";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
var ClientReport = function () {
    var _a;
    var navigate = useNavigate();
    var location = useLocation();
    var _b = __read(React.useState(false), 2), MFRegistration = _b[0], setMFRegistration = _b[1];
    var _c = __read(React.useState(false), 2), SipOrderBook = _c[0], setSipOrderBook = _c[1];
    var _d = __read(React.useState(false), 2), loader = _d[0], setLoader = _d[1];
    var _e = __read(React.useState(""), 2), userId = _e[0], setUserId = _e[1];
    var _f = __read(React.useState(""), 2), empCodeTxt = _f[0], setEmpCodeTxt = _f[1];
    var _g = __read(React.useState(""), 2), empName = _g[0], setEmpName = _g[1];
    var backOfficeYears = [
        { title: "FY 2014-2015 Onwards", value: "2014-2015" },
        { title: "FY 2013-2014", value: "2013-2014" },
    ];
    var backUrl = useSelector(function (state) { return state.Clients.ClientBackOfficeUrl.reducersData.data; });
    var backUrlLoader = useSelector(function (state) { return state.Clients.ClientBackOfficeUrl.commonData; }).loader;
    var passThroughLink = useSelector(function (state) { return state.Clients.ClientPassthrough.reducersData.data; });
    var passThroughLinkLoader = useSelector(function (state) { return state.Clients.ClientPassthrough.commonData; }).loader;
    var _h = __read(React.useState(backOfficeYears[0]), 2), backUrlYear = _h[0], setBackUrlYear = _h[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.PartnerCategory);
    var getUserid = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setUserId;
                    return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); };
    var getemployeecodetxt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setEmpCodeTxt;
                    return [4 /*yield*/, accountDetails.getSalesEmployeeCode()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); };
    var getEmployeeName = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setEmpName;
                    return [4 /*yield*/, accountDetails.getSalesEmpName()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) {
            getUserid();
            getemployeecodetxt();
            getEmployeeName();
        }
    }, [selectedAcount]);
    var getPaassthroughData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payloadPassthrough;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!empCodeTxt) return [3 /*break*/, 2];
                    payloadPassthrough = {
                        acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        empcodeTxt: empCodeTxt,
                        page: "1",
                        pageSize: "100",
                    };
                    return [4 /*yield*/, di.clients.getClientPassthroughData(payloadPassthrough)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode) && empCodeTxt)
            getPaassthroughData();
    }, [selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode, empCodeTxt]);
    var getBackOfficeUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients.getClientBackOfficeUrlData({
                        acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        year: backUrlYear === null || backUrlYear === void 0 ? void 0 : backUrlYear.value,
                        empName: empName,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode) && empName)
            getBackOfficeUrl();
    }, [backUrlYear, selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode, empName]);
    var routeToViewTransactionHistory = function () {
        var url = new URL(process.env.VIEW_REPORTS_TRANSACTION_HISTORY);
        url.searchParams.append("AcCode", selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode);
        url.searchParams.append("LogedIn", userId);
        url.searchParams.append("LogedInModule", "2");
        // window.open(url.toString(), "_blank");
        return url.toString();
    };
    var downloadPrismReports = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoader(true);
                    return [4 /*yield*/, di.clients
                            .downloadPrismReports({
                            Accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        })
                            .then(function (downloadprismresponse) {
                            if (!!downloadPrismReports &&
                                !!downloadprismresponse.data &&
                                downloadprismresponse.data !== "") {
                                alert("Your Prism file will download soon...");
                                base64toExcel(downloadprismresponse.data, "Prism_Reports_" +
                                    getDateInFormat(new Date(), "DD_MM_YYYY") +
                                    ".xlsx");
                            }
                            setLoader(false);
                        })
                            .catch(function (error) {
                            alert("Something is wrong please try again later");
                            setLoader(false);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null, passThroughLinkLoader || loader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : SipOrderBook ? (React.createElement(MfSipOrderBook, { closeSip: setSipOrderBook })) : (React.createElement(React.Fragment, null, MFRegistration ? (React.createElement(MFSIPRegistrationBook, { closeMf: setMFRegistration })) : (React.createElement(React.Fragment, null,
        React.createElement("section", { id: "client-report" },
            React.createElement(Row, { className: "d-flex align-items-center" },
                React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 heading-padding" }, "Navigate"),
                partnerCategory !== null &&
                    partnerCategory !== undefined &&
                    partnerCategory !== "" &&
                    (partnerCategory === null || partnerCategory === void 0 ? void 0 : partnerCategory.length) > 0 &&
                    partnerCategory === "BP" ? ("") : (React.createElement(Col, { xl: 3 },
                    React.createElement(EdALinkButton, { btnTyp: "midnight-blue", LinkHref: (_a = passThroughLink[0]) === null || _a === void 0 ? void 0 : _a.urlEncrypted, value: "Nuvamawealth.com", className: "text-start nuvama-web" }))),
                React.createElement(Col, { className: "DMSanN_16_400 txt_black-seven d-flex align-items-center" },
                    "Back office Reports:\u00A0",
                    React.createElement(GenericDropdown, { externalClassname: "sales-dropdown back-office", itemlist: backOfficeYears, defaultVal: true, selectedValue: setBackUrlYear }),
                    "\u00A0\u00A0",
                    React.createElement(EdALinkButton, { target: "_blank", btnTyp: "midnight-blue", LinkHref: backUrl === null || backUrl === void 0 ? void 0 : backUrl.strRptLnk, value: "Go", className: "text-start px-2 py-1 back-url " })),
                partnerCategory !== null &&
                    partnerCategory !== undefined &&
                    partnerCategory !== "" &&
                    (partnerCategory === null || partnerCategory === void 0 ? void 0 : partnerCategory.length) > 0 &&
                    partnerCategory === "BP" && React.createElement(Col, { xl: 3 })))))))));
};
export default ClientReport;
